(function () {
  const index = Array.isArray(window.HEFT_SEARCH_INDEX) ? window.HEFT_SEARCH_INDEX : [];
  const basePath = /\/heft-home-(originals|select)-products\//.test(window.location.pathname) ? "../" : "";
  const normalize = (value) => String(value || "").toLowerCase().replace(/[^a-z0-9]+/g, " ").trim();
  const tokens = (value) => normalize(value).split(" ").filter(Boolean);

  const categoryRoutes = {
    "ashley-living-room.html": "/search?type=product&q=Ashley+Living+Room",
    "ashley-sectionals.html": "/search?type=product&q=Ashley+Sectionals",
    "ashley-sofas.html": "/search?type=product&q=Ashley+Sofas",
    "ashley-loveseats.html": "/search?type=product&q=Ashley+Loveseats",
    "ashley-reclining.html": "/search?type=product&q=Ashley+Reclining",
    "ashley-chairs.html": "/search?type=product&q=Ashley+Chairs",
    "ashley-ottomans.html": "/search?type=product&q=Ashley+Ottomans",
    "ashley-living-room-sets.html": "/search?type=product&q=Ashley+Living+Room+Sets",
    "ashley-chaises.html": "/search?type=product&q=Ashley+Chaises",
    "ashley-dining-room.html": "/search?type=product&q=Ashley+Dining+Room",
    "ashley-dining-room-sets.html": "/search?type=product&q=Ashley+Dining+Room+Sets",
    "ashley-dining-tables.html": "/search?type=product&q=Ashley+Dining+Tables",
    "ashley-dining-chairs.html": "/search?type=product&q=Ashley+Dining+Chairs",
    "ashley-stools.html": "/search?type=product&q=Ashley+Stools",
    "ashley-servers.html": "/search?type=product&q=Ashley+Servers",
    "ashley-benches.html": "/search?type=product&q=Ashley+Benches",
    "ashley-bedroom.html": "/search?type=product&q=Ashley+Bedroom",
    "ashley-beds.html": "/search?type=product&q=Ashley+Beds",
    "ashley-bedroom-sets.html": "/search?type=product&q=Ashley+Bedroom+Sets",
    "ashley-dressers.html": "/search?type=product&q=Ashley+Dressers",
    "ashley-dresser-mirror.html": "/search?type=product&q=Ashley+Dresser+Mirror",
    "ashley-nightstands.html": "/search?type=product&q=Ashley+Nightstands",
    "ashley-chests.html": "/search?type=product&q=Ashley+Chests",
    "ashley-headboards.html": "/search?type=product&q=Ashley+Headboards",
    "ashley-mattresses.html": "/search?type=product&q=Ashley+Mattresses",
    "ashley-home-entertainment.html": "/search?type=product&q=Ashley+Home+Entertainment",
    "ashley-tv-stands.html": "/search?type=product&q=Ashley+TV+Stands",
    "ashley-entertainment-centers.html": "/search?type=product&q=Ashley+Entertainment+Centers",
    "ashley-fireplace-tv-stands.html": "/search?type=product&q=Ashley+Fireplace+TV+Stands",
    "ashley-home-accents.html": "/search?type=product&q=Ashley+Home+Accents",
    "ashley-rugs.html": "/search?type=product&q=Ashley+Rugs",
    "ashley-lighting.html": "/search?type=product&q=Ashley+Lighting",
    "ashley-wall-art.html": "/search?type=product&q=Ashley+Wall+Art",
    "ashley-mirrors.html": "/search?type=product&q=Ashley+Mirrors",
    "ashley-pillows.html": "/search?type=product&q=Ashley+Pillows",
    "ashley-table-decor.html": "/search?type=product&q=Ashley+Table+Decor",
    "ashley-clocks.html": "/search?type=product&q=Ashley+Clocks",
    "ashley-home-office.html": "/search?type=product&q=Ashley+Home+Office",
    "ashley-desks.html": "/search?type=product&q=Ashley+Desks",
    "ashley-bookcases.html": "/search?type=product&q=Ashley+Bookcases",
    "ashley-outdoor.html": "/search?type=product&q=Ashley+Outdoor",
    "ashley-outdoor-sets.html": "/search?type=product&q=Ashley+Outdoor+Sets",
    "ashley-outdoor-seating.html": "/search?type=product&q=Ashley+Outdoor+Seating",
    "ashley-fire-pits-tables.html": "/search?type=product&q=Ashley+Fire+Pits+Tables",
    "ashley-kids-teens.html": "/search?type=product&q=Ashley+Kids+Teens",
    "ashley-entryway-furniture.html": "/search?type=product&q=Ashley+Entryway+Furniture"
  };

  const pageRoutes = {
    "in-store-clearance.html": "/pages/in-store-clearance",
    "heft-home-originals.html": "/pages/heft-home-originals",
    "heft-home-select.html": "/pages/heft-home-select",
    "live-edge.html": "/pages/live-edge",
    "financing.html": "/pages/financing",
    "index-reimagined.html#visit": "/#visit"
  };

  function productHandle(title) {
    return normalize(title)
      .replace(/\b(ashley|signature|design|by|benchcraft)\b/g, " ")
      .replace(/\s+/g, " ")
      .trim()
      .replace(/\s+/g, "-");
  }

  function localUrl(url, item) {
    if (!url) return "/search?type=product";
    if (item && item.type === "product" && url.startsWith("/search?") && item.title) {
      return `/products/${productHandle(item.title)}`;
    }
    if (categoryRoutes[url]) return categoryRoutes[url];
    if (pageRoutes[url]) return pageRoutes[url];
    if (url.startsWith("/search?")) return url;
    if (url.startsWith("http") || url.startsWith("/") || url.startsWith("#")) return url;
    return basePath + url;
  }

  function searchProductQuery(href) {
    try {
      const url = new URL(href, window.location.origin);
      if (url.pathname !== "/search") return "";
      if (url.searchParams.get("type") !== "product") return "";
      return url.searchParams.get("q") || "";
    } catch (error) {
      return "";
    }
  }

  function exactProductForQuery(query) {
    const q = normalize(query);
    if (!q) return null;
    return index.find((item) => {
      if (!item || item.type !== "product") return false;
      return normalize(item.sku) === q || normalize(item.title) === q;
    }) || null;
  }

  function exactItemForQuery(query) {
    const q = normalize(query);
    if (!q) return null;
    return exactProductForQuery(query) || index.find((item) => {
      if (!item) return false;
      return normalize(item.title) === q || normalize(item.sku) === q;
    }) || null;
  }

  function productUrlForSearchHref(href) {
    const query = searchProductQuery(href);
    const product = exactProductForQuery(query);
    return product ? localUrl(product.url, product) : "";
  }

  function rewriteProductSearchLinks() {
    document.querySelectorAll('a[href*="/search"][href*="type=product"][href*="q="]').forEach((link) => {
      const productUrl = productUrlForSearchHref(link.getAttribute("href"));
      if (productUrl) link.setAttribute("href", productUrl);
    });
  }

  function routeProductSearchClick(event) {
    const link = event.target.closest && event.target.closest('a[href*="/search"]');
    if (!link) return;
    const productUrl = productUrlForSearchHref(link.getAttribute("href"));
    if (!productUrl) return;
    event.preventDefault();
    window.location.href = productUrl;
  }

  function score(item, query) {
    const q = normalize(query);
    if (!q) return 0;
    const hay = normalize([item.title, item.brand, item.category, item.sku, item.terms].join(" "));
    let total = 0;
    if (normalize(item.sku) === q) total += 120;
    if (normalize(item.title) === q) total += 90;
    if (normalize(item.title).startsWith(q)) total += 55;
    if (normalize(item.category).includes(q)) total += item.type === "category" ? 52 : 24;
    if (hay.includes(q)) total += 20;
    tokens(q).forEach((token) => {
      if (normalize(item.sku).startsWith(token)) total += 48;
      if (normalize(item.title).includes(token)) total += 22;
      if (normalize(item.category).includes(token)) total += 18;
      if (hay.includes(token)) total += 8;
    });
    if (item.type === "category") total += 12;
    return total;
  }

  function search(query, limit) {
    return index
      .map((item) => ({ item, score: score(item, query) }))
      .filter((entry) => entry.score > 0)
      .sort((a, b) => b.score - a.score || String(a.item.title).localeCompare(String(b.item.title)))
      .slice(0, limit)
      .map((entry) => entry.item);
  }

  function resultMarkup(item, compact) {
    const image = item.image ? `<img src="${item.image}" alt="${item.title}"/>` : `<span>${item.type === "category" ? "SHOP" : "HEFT"}</span>`;
    const meta = [item.brand, item.category, item.sku].filter(Boolean).join(" / ");
    return `<a class="${compact ? "search-suggestion" : "search-result-card"}" href="${localUrl(item.url, item)}">
      <span class="search-thumb">${image}</span>
      <span class="search-result-copy">
        <strong>${item.title}</strong>
        <em>${meta}</em>
        ${item.price ? `<small>${item.price}</small>` : ""}
      </span>
    </a>`;
  }

  function replaceBrokenImage(img) {
    if (!img || img.dataset.heftFallbackApplied === "true") return;
      if (img.dataset.heftFallbackApplied === "true") return;
      const fallback = window.HEFT_IMAGE_FALLBACK || "";
      if (!fallback) return;
      img.dataset.heftFallbackApplied = "true";
      img.classList.add("heft-image-fallback");
      img.alt = img.alt || "HEFT Home showroom";
      img.src = fallback;
  }

  function applyImageFallback(img) {
    if (!img || img.dataset.heftFallbackReady === "true") return;
    img.dataset.heftFallbackReady = "true";
    img.addEventListener("error", () => replaceBrokenImage(img));
    if (img.complete && img.naturalWidth === 0) {
      replaceBrokenImage(img);
    }
  }

  function bindImageFallbacks(root) {
    (root || document).querySelectorAll("img").forEach(applyImageFallback);
  }

  function enhanceForm(form) {
    const input = form.querySelector('input[name="q"]');
    if (!input) return;
    let panel = form.querySelector(".search-suggestions");
    if (!panel) {
      panel = document.createElement("div");
      panel.className = "search-suggestions";
      panel.setAttribute("role", "listbox");
      form.appendChild(panel);
    }

    const renderSuggestions = () => {
      const query = input.value.trim();
      if (query.length < 2) {
        panel.innerHTML = "";
        panel.dataset.open = "false";
        return;
      }
      const matches = search(query, 8);
      panel.innerHTML = matches.length
        ? matches.map((item) => resultMarkup(item, true)).join("")
        : `<div class="search-empty">No exact match. Try a SKU, sofa, sectional, dining, bedroom, Ashley, Originals, or Select.</div>`;
      bindImageFallbacks(panel);
      panel.dataset.open = "true";
    };

    input.addEventListener("input", renderSuggestions);
    input.addEventListener("focus", renderSuggestions);
    document.addEventListener("click", (event) => {
      if (!form.contains(event.target)) panel.dataset.open = "false";
    });

    form.addEventListener("submit", (event) => {
      event.preventDefault();
      const query = input.value.trim();
      if (!query) return;
      const exact = exactItemForQuery(query);
      if (exact) {
        window.location.href = localUrl(exact.url, exact);
        return;
      }
      window.location.href = `/search?type=product&q=${encodeURIComponent(query)}`;
    });
  }

  function renderResultsPage() {
    const root = document.querySelector("[data-search-results]");
    if (!root) return;
    const params = new URLSearchParams(window.location.search);
    const query = params.get("q") || "";
    const input = document.querySelector("[data-search-page-input]");
    if (input) input.value = query;
    const matches = query ? search(query, 48) : index.filter((item) => item.type === "category").slice(0, 24);
    root.innerHTML = matches.length
      ? matches.map((item) => resultMarkup(item, false)).join("")
      : `<div class="search-no-results"><h2>No exact match.</h2><p>Try a SKU, product name, brand, or category like sofa, sectional, dining, bedroom, Ashley, Originals, or Select.</p><a href="/#visit" class="primary-action">Visit showroom</a></div>`;
    bindImageFallbacks(root);
    const count = document.querySelector("[data-search-count]");
    if (count) count.textContent = query ? `${matches.length} results for "${query}"` : "Popular categories";
  }

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".site-search, [data-search-form]").forEach(enhanceForm);
    rewriteProductSearchLinks();
    document.addEventListener("click", routeProductSearchClick);
    document.addEventListener("error", (event) => {
      if (event.target && event.target.tagName === "IMG") replaceBrokenImage(event.target);
    }, true);
    bindImageFallbacks(document);
    renderResultsPage();
  });
})();
